// Reglas tomadas de la referencia de Alanube Panamá (createcompany, createoffice, getruc).
// Se repiten en la API (Dtos.cs); la API es la que decide.

export const RX = {
  codigoSucursal: /^\S{4}$/,
  // Ficha técnica DGI (dTfnEm), confirmado por Alanube: 7 a 12 caracteres, 999-9999 o 9999-9999.
  telefono: /^(\d{3}-\d{4}|\d{4}-\d{4})$/,
  coordenadas: /^\+\d{1,2}\.\d{1,7},-\d{2}\.\d{1,7}$/,
  ubicacion: /^\d{1,2}-\d{1,2}-\d{1,2}$/,
  puntoFacturacion: /^(?!000)\d{3}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

export const LIMITES = {
  rucMin: 5,
  rucMax: 20,
  nombreComercialMin: 2,
  nombreComercialMax: 200,
  direccionMax: 100,
  emailSucursalMax: 50,
  logoBytes: 150 * 1024,
  numeracionMax: 9_999_999_999,
};

export const LOGO_MIME = ['image/jpeg', 'image/png', 'image/webp'];

export function esCertificado(f: File) {
  return /\.(p12|pfx)$/i.test(f.name);
}

/** Convierte lat/long del navegador al formato de Alanube: +8.4488725,-82.4213875 */
export function formatearCoordenadas(lat: number, lon: number): string | null {
  if (lat < 0 || lon > 0) return null; // el formato de Alanube sólo admite latitud + y longitud -
  return `+${lat.toFixed(7)},${lon.toFixed(7)}`;
}

export function diasParaVencer(fechaIso: string | null): number | null {
  if (!fechaIso) return null;
  const ms = new Date(fechaIso).getTime() - Date.now();
  return Math.floor(ms / 86_400_000);
}

export function fecha(fechaIso: string | null): string {
  if (!fechaIso) return '—';
  return new Date(fechaIso).toLocaleDateString('es-PA', { day: '2-digit', month: 'short', year: 'numeric' });
}
